<template>
  <section class="container-fluid">
    <div>
      <div class="mb-4 text-center">
        <h1>PDP Goals</h1>
      </div>
      <div>
        <grid
          :entityTypeId="entityTypeId"
          :formId="formId"
          :entityTypeName="entityTypeName"
          :primaryEntity="primaryentity"
          :showLastUpdated="showLastUpdated"
          :showFormOnEmpty="true"
          :showComments="true"
          :basePageSize="gridPageSize"
          :baseCurrentPage="gridCurrentPage"
          @setPageSize="setPageSize"
          @setCurrentPage="setCurrentPage"
        >
        </grid>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PDPGoals',
  data() {
    return {
      entityTypeId: 12,
      formId: 11,
      entityTypeName: 'PDP Goals',
      showLastUpdated: true,
      gridPageSize: 5,
      gridCurrentPage: 1
    };
  },
  props: {
    primaryentity: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    setPageSize(size) {
      this.gridPageSize = parseInt(size);
    },
    setCurrentPage(page) {
      this.gridCurrentPage = parseInt(page);
    }
  }
};
</script>
